import { Fragment, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CreateContractDraftDialog } from 'app/domains/templates';
import { TemplateBrowserModal } from './TemplateBrowserModal';
export function CreateDocumentDialog(props) {
    const { open, onClose } = props;
    const [selectedIds, setSelectedIds] = useState(null);
    const history = useHistory();
    const handleHideCreateModal = () => setSelectedIds(null);
    const handleDraftCreated = (draftId) => {
        history.push(`/draft/${draftId}`);
    };
    return (<Fragment>
      {!selectedIds && (<TemplateBrowserModal onClose={onClose} onSubmit={setSelectedIds} open={open}/>)}
      {selectedIds && (<CreateContractDraftDialog composerId={selectedIds.composerId} templateId={selectedIds.templateId} onClose={handleHideCreateModal} onDraft={({ id }) => handleDraftCreated(id)}/>)}
    </Fragment>);
}
